package uz.ferro.erp.ui.header

import mui.icons.material.HelpOutline
import mui.icons.material.Login
import mui.icons.material.Logout
import mui.icons.material.ShoppingCart
import mui.material.Box
import mui.material.IconButton
import mui.system.sx
import react.FC
import react.useContext
import react.useState
import uz.ferro.erp.Colors
import uz.ferro.erp.NavigationContext
import uz.ferro.erp.feature.auth.LoginDialog
import uz.ferro.erp.manager.AuthManager
import uz.ferro.erp.navigator.NavigationPage
import uz.ferro.erp.pages.MAX_PAGE_AREA
import uz.ferro.erp.ui.AppText
import uz.ferro.erp.ui.HorizontalLayout
import uz.ferro.erp.ui.ImageView
import web.cssom.AlignItems
import web.cssom.Auto
import web.cssom.Cursor
import web.cssom.Position
import web.cssom.integer
import web.cssom.number
import web.cssom.pct
import web.cssom.px

val HeaderDesktop = FC {
    val navigator = useContext(NavigationContext)
    var authDialogShown by useState(false)
    var isAuthorized by useState(AuthManager.isAuthorized())

    Box {
        sx {
            width = 100.pct
            height = 90.px
            position = Position.relative
            backgroundColor = Colors.white
        }

        Box {
            sx {
                width = 100.pct
                height = 48.px
                zIndex = integer(2)
            }

            HorizontalLayout {
                sx {
                    width = 100.pct
                    maxWidth = MAX_PAGE_AREA
                    marginLeft = Auto.auto
                    marginRight = Auto.auto
                    paddingLeft = 16.px
                    paddingRight = 16.px
                    alignItems = AlignItems.center
                }

                Box {
                    sx {
                        width = 180.px
                        height = 53.px
                        marginTop = 16.px
                        marginBottom = 16.px
                        cursor = Cursor.pointer
                    }

                    ImageView {
                        sx {
                            width = 100.pct
                            height = 100.pct
                        }
                        url = "/icons/ferro_logo.svg"
                    }

                    onClick = {
                        navigator.openMain()
                    }
                }

                Box {
                    sx {
                        flexGrow = number(1.0)
                    }
                }


                HorizontalLayout {
                    sx {
                        alignItems = AlignItems.center
                        cursor = Cursor.pointer
                    }

                    onClick = {
                        navigator.openPage(NavigationPage.FAQ)
                    }

                    IconButton {
                        HelpOutline {
                            htmlColor = Colors.iconPrimary
                        }
                    }
                    AppText {
                        size = 18
                        text = "Yordam"
                    }
                }

                Box {
                    sx {
                        width = 32.px
                    }
                }

                if (isAuthorized) {
                    HorizontalLayout {
                        sx {
                            alignItems = AlignItems.center
                            cursor = Cursor.pointer
                        }
                        onClick = {
                            navigator.openPage(NavigationPage.ORDER_LIST)
                        }
                        IconButton {
                            ShoppingCart {
                                htmlColor = Colors.iconPrimary
                            }
                            onClick = {
                                navigator.openPage(NavigationPage.ORDER_LIST)
                            }
                        }
                        AppText {
                            size = 18
                            text = "Buyurtmalar"
                        }
                    }

                    Box {
                        sx {
                            width = 32.px
                        }
                    }

                    HorizontalLayout {
                        sx {
                            alignItems = AlignItems.center
                            cursor = Cursor.pointer
                        }
                        onClick = {
                            AuthManager.logout()
                            isAuthorized = false
                        }
                        IconButton {
                            Logout {
                                htmlColor = Colors.iconPrimary
                            }
                            onClick = {
                                AuthManager.logout()
                                isAuthorized = false
                            }
                        }
                        AppText {
                            size = 18
                            text = "Chiqish"
                        }
                    }
                } else {
                    HorizontalLayout {
                        sx {
                            alignItems = AlignItems.center
                            cursor = Cursor.pointer
                        }
                        onClick = {
                            authDialogShown = true
                        }
                        IconButton {
                            Login {
                                htmlColor = Colors.iconPrimary
                            }
                            onClick = {
                                authDialogShown = true
                            }
                        }
                        AppText {
                            size = 18
                            text = "Kirish"
                        }
                    }
                }
            }
        }
    }

    LoginDialog {
        isOpen = authDialogShown
        onClose = {
            authDialogShown = false
        }
        onLoginSuccess = {
            isAuthorized = AuthManager.isAuthorized()
        }
    }
}